export default __webpack_public_path__ + "static/media/Rick_and_Morty_logo.de13d484.png";